import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';
import { SharedModule } from '../shared/shared.module';
import { IsSmartFilterGroupingPipe } from './pipes/is-smart-filter-group.pipe';
import { IsSmartFilterPipe } from './pipes/is-smart-filter.pipe';
import { CastAsHydratedSmartFilterPipe } from './pipes/cast-as-hydrated-smart-filter.pipe';
import { IsHydratedSmartFilterPipe } from './pipes/is-hydrated-smart-filter.pipe';
import { CastAsSmartFilterGroupingPipe } from './pipes/cast-as-smart-filter-grouping.pipe';
import { AddEditSmartFilterModalComponent } from './modal/add-edit-smart-filter-modal/add-edit-smart-filter-modal.component';
import { AddEditSmartFilterViewModel } from './modal/add-edit-smart-filter-modal/add-edit-smart-filter-view-model';
import { ReactiveFormModule } from '@mobilefirstdev/reactive-form';
import { EditSmartFilterCategoryModalComponent } from './modal/edit-smart-filter-category-modal/edit-smart-filter-category-modal.component';
import { SmartFilterCardRowComponent } from './components/smart-filter-card-row/smart-filter-card-row.component';
import { SmartFilterCardComponent } from './components/smart-filter-card-row/smart-filter-card/smart-filter-card.component';
import { SmartFiltersRowMiscButtonComponent } from './components/smart-filter-card-row/add-more-smart-filters-row-button/smart-filters-row-misc-button.component';
import { SmartFilterCategoryCardComponent } from './components/smart-filter-card-row/smart-filter-category-card/smart-filter-category-card.component';
import { SmartFilterSelectionModalComponent } from './modal/smart-filter-selection-modal/smart-filter-selection-modal.component';
import { SmartFilterSelectionGroupComponent } from './components/smart-filter-selection-group/smart-filter-selection-group.component';
import { SmartFilterSelectionComponent } from './components/smart-filter-selection/smart-filter-selection.component';
import { SmartFilterGroupSelectionComponent } from './components/smart-filter-selection/smart-filter-group-selection/smart-filter-group-selection.component';
import { AdvancedAddEditSmartFilterFormComponent } from './forms/add-edit-smart-filter-form/advanced-add-edit-smart-filter-form/advanced-add-edit-smart-filter-form.component';
import { BasicAddEditSmartFilterFormComponent } from './forms/add-edit-smart-filter-form/basic-add-edit-smart-filter-form/basic-add-edit-smart-filter-form.component';
import { ProductLabelsModule } from '../../modules/product-labels/product-labels.module';
import { SmartFiltersSectionComponent } from './components/smart-filters-section/smart-filters-section.component';
import { SmartFilterLineItemComponent } from './components/smart-filter-line-item/smart-filter-line-item.component';
import { LoadingShimmerComponent } from '@mobilefirstdev/loading-shimmer';
import { ReactiveButtonsModule } from '@mobilefirstdev/reactive-buttons';
import { ProductAddEditSmartFilterFormComponent } from './forms/add-edit-smart-filter-form/product-add-edit-smart-filter-form/product-add-edit-smart-filter-form.component';
import { CannabinoidAddEditSmartFilterFormComponent } from './forms/add-edit-smart-filter-form/cannabinoid-add-edit-smart-filter-form/cannabinoid-add-edit-smart-filter-form.component';
import { RxFor } from '@rx-angular/template/for';
import { RxPush } from '@rx-angular/template/push';
import { TerpeneAddEditSmartFilterFormComponent } from './forms/add-edit-smart-filter-form/terpene-add-edit-smart-filter-form/terpene-add-edit-smart-filter-form.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { RxIf } from '@rx-angular/template/if';
import { ToastModule } from '../../modules/toasts/toast.module';

@NgModule({
  declarations: [
    IsSmartFilterGroupingPipe,
    IsSmartFilterPipe,
    CastAsHydratedSmartFilterPipe,
    IsHydratedSmartFilterPipe,
    CastAsSmartFilterGroupingPipe,
    AddEditSmartFilterModalComponent,
    EditSmartFilterCategoryModalComponent,
    SmartFilterCardRowComponent,
    SmartFilterCardComponent,
    SmartFilterCategoryCardComponent,
    SmartFiltersRowMiscButtonComponent,
    SmartFilterSelectionModalComponent,
    SmartFilterSelectionGroupComponent,
    SmartFilterSelectionComponent,
    SmartFilterGroupSelectionComponent,
    AdvancedAddEditSmartFilterFormComponent,
    BasicAddEditSmartFilterFormComponent,
    ProductAddEditSmartFilterFormComponent,
    CannabinoidAddEditSmartFilterFormComponent,
    TerpeneAddEditSmartFilterFormComponent,
    SmartFiltersSectionComponent,
    SmartFilterLineItemComponent
  ],
  exports: [
    IsSmartFilterGroupingPipe,
    IsSmartFilterPipe,
    CastAsHydratedSmartFilterPipe,
    IsHydratedSmartFilterPipe,
    CastAsSmartFilterGroupingPipe,
    AddEditSmartFilterModalComponent,
    EditSmartFilterCategoryModalComponent,
    SmartFilterCardRowComponent,
    SmartFilterCardComponent,
    SmartFiltersRowMiscButtonComponent,
    SmartFilterCategoryCardComponent,
    SmartFilterSelectionModalComponent,
    SmartFiltersSectionComponent,
    SmartFilterLineItemComponent
  ],
  imports: [
    CommonModule,
    ToastModule,
    MatRippleModule,
    FlexLayoutModule,
    SharedModule,
    ReactiveFormModule,
    ProductLabelsModule,
    LoadingShimmerComponent,
    ReactiveButtonsModule,
    RxFor,
    RxPush,
    RxIf
  ],
  providers: [AddEditSmartFilterViewModel]
})
export class SmartFiltersModule {}
